<template>
  <v-card style="width: 100%" :height="height" flat>
    <v-flex layout row>
      <v-flex md4 class="pa-0">
        <v-flex layout column>
          <v-flex layout pt-2 pb-2 pl-2 align-center justify-center>
            <span class="missionName">
              {{ findMissionById.name.fr }}
            </span>
          </v-flex>
          <v-img
            v-if="
              missionTab == 'mission' &&
              findMissionById.pictures &&
              findMissionById.pictures[0]
            "
            :src="findMissionById.pictures[0].url"
            :height="height - 50"
          ></v-img>
          <v-card
            v-if="missionTab !== 'mission' && hasTrackedGames"
            flat
            :height="height - 50"
          >
            <v-card-text class="font-italic centerChart" v-if="instructionGame">
              {{ instructionGame }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-flex>
      <v-flex md8 layout column>
        <v-flex layout row pa-2 style="max-height: 50px">
          <v-item-group>
            <v-chip
              ma-2
              label
              :outline="missionTab == 'mission' ? true : false"
              small
              :color="missionTab == 'mission' ? 'primary' : 'white'"
              @click="changeMissionTab('mission')"
              :selected="missionTab == 'mission'"
              class="elevation-0 pointerClass"
            >
              <span class="chipText pointerClass"> mission </span>
            </v-chip>
            <v-chip
              ma-2
              label
              small
              :outline="missionTab == gameId ? true : false"
              :color="missionTab == gameId ? 'primary' : 'white'"
              v-for="(gameId, index) in findMissionGames"
              :key="gameId"
              @click="changeMissionTab(gameId)"
              :selected="missionTab == gameId"
              class="elevation-0 pointerClass"
            >
              <span class="chipText pointerClass">
                {{ $tc('statsMissionCard.game', index + 1) }}
              </span>
            </v-chip>
          </v-item-group>
        </v-flex>
        <v-flex pt-4>
          <v-card height="200" width="450" flat>
            <!-- <stats-charts
            v-if="missionTab=='mission' && isValuesMission"
            :gameProperties="gameProperties"
            :graphType="'pieMission'"
            :datas="valuesMission"
            :labels="labelsMission"
            class="mx-auto centerChart">
            </stats-charts>
            --><!--stats-survey
            v-if="isSurvey"
            :height="150"
            :datas="getStatsGame"
            class="mx-auto centerChart">
            </stats-survey-->
            <v-card
              v-if="isSurveyText"
              v-for="(answer, index) in getStatsGame"
              style="padding: 15px"
              :key="index"
            >
              {{ answer.word || answer.value }}
            </v-card>
            <stats-charts
              v-if="missionTab === 'mission'"
              :gameProperties="gameProperties"
              :isMcqImage="isMcqImage"
              :gameId="missionTab"
              class="mx-auto centerChart"
            ></stats-charts>

            <stats-charts
              v-if="!isSurveyText"
              :gameProperties="gameProperties"
              :isMcqImage="isMcqImage"
              :gameId="missionTab"
              class="mx-auto centerChart"
            ></stats-charts>

            <v-card class="banner" color="rgba(230,230,230,0.3)">
              <p
                style="margin-top: 16px"
                v-if="
                  missionTab !== 'mission' && hasTrackedGames && !isGameValid
                "
              >
                {{ $t('statsMissionCard.noStatsGame') }}
              </p>
              <p
                style="margin-top: 16px"
                v-if="missionTab === 'mission' && !isValuesMission"
              >
                {{ $t('statsMissionCard.noStatsMission') }}
              </p>
            </v-card>
          </v-card>
        </v-flex>
      </v-flex>
      <v-card
        v-if="missionTab !== 'mission' && !hasTrackedGames"
        class="banner"
        color="rgba(230,230,230,0.3)"
      >
        <p style="margin-top: 16px">
          {{ $t('statsMissionCard.noStatsGamesMission') }} <br /><br />
          {{ $t('statsMissionCard.createTrackedGames') }}
        </p>
      </v-card>
    </v-flex>
  </v-card>
</template>

<script>
import StatsCharts from './StatsCharts';
import StatsPictures from './StatsPictures';

export default {
  components: { StatsCharts, StatsPictures },
  props: {
    missionId: {
      required: false,
      default: null,
    },
    statsMission: {
      required: false,
      default: null,
    },
    height: {
      type: Number,
      default: 250,
    },
    width: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      missionTab: 'mission',
      gameProperties: {},
      gameTypeVariables: {
        mcq: {
          answers: 'nbClicks',
          label: 'value',
          graphType: 'pie',
          data: {},
          labels: {},
        },
        text: {
          answers: 'nbPlayers',
          label: 'word',
          graphType: 'horizontalBar',
          data: {},
          labels: {},
        },
        move: {
          answers: 'nbPlayers',
          label: 'nbMovements',
          graphType: 'bar',
          data: {},
          labels: {},
        },
        action: {
          answers: ['nbTries', 'nbSucess'],
          label: { trueLabels: ['Succes'], falseLabels: ['Échecs'] },
          graphType: '',
          data: {},
          labels: {},
        },
        picture: {
          answers: 'pictureTaken',
          label: '',
          graphType: 'picture',
          data: {},
          labels: {},
        },
      },
    };
  },
  mounted() {
    if (this.missionTab === 'mission') {
      this.gameProperties = {
        mission: { data: this.valuesMission, labels: this.labelsMission },
      };
    }
  },
  computed: {
    gameInfo() {
      return this.$store.getters['missions/getGames'](this.missionTab) || null;
    },
    gameCategory() {
      const gameId = this.missionTab;
      if (this.isTrackedGame) {
        const gameSelected = this.trackedGames.find((g) => g.gameId === gameId);
        if (!gameSelected) {
          return null;
        }
        if (gameSelected.reflexionGames) {
          if (gameSelected.reflexionGames[0].word) {
            return 'text';
          }
          return 'move';
        } else if (gameSelected.mcqAnswers) {
          return 'mcq';
        } else if (gameSelected.actionGames[0].pictureTaken) {
          return 'picture';
        }
        return 'action';
      } else if (
        this.gameInfo &&
        (this.gameInfo.type === 'takePicture' ||
          this.gameInfo.type === 'takeSelfie')
      ) {
        return 'picture';
      }
    },
    instructionGame() {
      // TODO: multilingue
      return this.gameInfo && this.gameInfo.instruction.text.fr;
    },
    findMissionById() {
      return this.$store.getters['missions/getMissionById'](this.missionId);
    },
    findMissionGames() {
      return this.$store.getters['missions/getMissionGames'](this.missionId);
    },
    valuesMission() {
      let wins = 0;
      let fails = 0;
      if (this.statsMission.nbWins) {
        wins = parseInt(this.statsMission.nbWins);
      }
      if (this.statsMission.nbStarts) {
        fails = parseInt(this.statsMission.nbStarts) - wins;
      }
      return { wins, fails };
    },
    isValuesMission() {
      let isValuesMission = false;
      Object.values(this.valuesMission).forEach((element) => {
        if (element !== 0) {
          isValuesMission = true;
        }
      });
      return isValuesMission;
    },
    labelsMission() {
      let wins = this.$t('statsMissionCard.wins');
      let fails = this.$t('statsMissionCard.fails');
      return { wins, fails };
    },
    trackedGames() {
      let trackedGames = this.statsMission.games;
      if (trackedGames.length > 0) {
        return trackedGames;
      }
      return [];
    },
    trackedGamesIds() {
      let trackedGamesIds = this.trackedGames.map((game) => game.gameId);
      return trackedGamesIds;
    },
    hasTrackedGames() {
      if (this.trackedGamesIds.length > 0) {
        return true;
      }
      return false;
    },
    isTrackedGame() {
      return this.trackedGamesIds.includes(this.missionTab);
    },
    hasUntrackedGames() {
      return this.trackedGamesIds.length < this.findMissionGames.length;
    },
    findUntrackedgames() {
      if (this.hasUntrackedGames) {
        return [
          ...new Set(
            this.findMissionGames.filter(
              (el) => !this.trackedGamesIds.includes(el)
            )
          ),
        ];
      }
    },
    getStatsGame() {
      if (this.missionTab === 'mission') {
        return null;
      } else if (
        !this.findUntrackedgames ||
        (this.findUntrackedgames &&
          !this.findUntrackedgames.includes(this.missionTab))
      ) {
        const game = this.statsMission.games.find(
          (g) => g.gameId === this.missionTab
        );
        return Object.keys(game)
          .filter((key) => key !== 'gameId')
          .reduce((result, key) => {
            return game[key];
          }, {});
      }
    },
    valuesGame() {
      let values = [];
      if (this.getStatsGame && this.getStatsGame.length > 0) {
        let answers = this.getStatsGame;
        if (this.gameTypeVariables[this.gameCategory].answers === 'nbClicks') {
          let trueValues = new Array(this.labelsGame.trueLabels.length).fill(0);
          let falseValues = new Array(this.labelsGame.falseLabels.length).fill(
            0
          );
          answers.forEach((answer) => {
            if (
              this.labelsGame.trueLabels.includes(answer.value || answer.url)
            ) {
              trueValues[
                this.labelsGame.trueLabels.indexOf(answer.value || answer.url)
              ] = answer.nbClicks;
            } else if (
              this.labelsGame.falseLabels.includes(answer.value || answer.url)
            ) {
              falseValues[
                this.labelsGame.falseLabels.indexOf(answer.value || answer.url)
              ] = answer.nbClicks;
            }
          });
          this.gameProperties[this.gameCategory].data =
            trueValues.concat(falseValues);
          return trueValues.concat(falseValues);
        } else if (this.gameCategory === 'action') {
          values = [
            answers[0].nbSuccess,
            answers[0].nbTries - answers[0].nbSuccess,
          ];
        } else {
          values = answers.map((answer) => {
            return answer[this.gameTypeVariables[this.gameCategory].answers];
          });
        }
      }
      this.gameProperties[this.gameCategory].data = values;
      return values;
    },
    isGameValid() {
      if (this.isSurveyText || this.gameCategory === 'picture') {
        return true;
      }

      if (this.gameCategory === 'mission') {
        if (
          this.valuesMission.hasOwnProperty('fails') &&
          this.valuesMission.hasOwnProperty('wins')
        ) {
          return true;
        }
      } else if (Object.keys(this.valuesGame).length > 0) {
        let nonZeroValues = Object.values(this.valuesGame).filter(
          (element) => element[0] !== '0'
        );

        console.log('nonZeroValues:', nonZeroValues);
        if (
          this.gameCategory === 'mcq' &&
          nonZeroValues.length > 0 &&
          this.labelsGame.hasOwnProperty('falseLabels') &&
          this.labelsGame.hasOwnProperty('trueLabels') &&
          this.labelsGame.falseLabels.length > 0 &&
          this.labelsGame.trueLabels.length > 0
        ) {
          return true;
        }
        if (
          this.gameCategory === 'mcqSurvey' &&
          nonZeroValues.length > 0 &&
          this.labelsGame.hasOwnProperty('trueLabels') &&
          this.labelsGame.trueLabels.length > 0
        ) {
          return true;
        } else if (nonZeroValues.length > 0) {
          if (
            this.labelsGame.length > 0 ||
            Object.keys(this.labelsGame).length > 0
          ) {
            return true;
          }
        }
      }
      return false;
    },
    isReflexionGame() {
      const gameId = this.missionTab;
      const gameSelected = this.trackedGames.find((g) => g.gameId === gameId);
      if (gameSelected && gameSelected.reflexionGames) {
        return true;
      }
      return false;
    },
    isSurveyText() {
      return this.gameInfo && this.gameInfo.type.includes('survey');
    },
    isMcqGame() {
      return this.gameInfo && this.gameInfo.type.includes('mcq');
    },
    reflexionGameType() {
      const gameId = this.missionTab;
      const gameSelected = this.trackedGames.filter((g) => g.gameId === gameId);

      if (this.isReflexionGame) {
        if (gameSelected[0].reflexionGames[0].word) {
          return 'word';
        }
        return 'move';
      }
      return null;
    },
    isActionGame() {
      const gameId = this.missionTab;
      const gameSelected = this.trackedGames.find((g) => g.gameId === gameId);
      if (gameSelected && gameSelected.actionGames) {
        return true;
      }
      return false;
    },
    isMcqImage() {
      return this.gameInfo && this.gameInfo.type === 'mcqImage';
    },
    labelsGame() {
      let labels = {};

      if (this.isSurveyText) {
        return labels;
      }

      if (this.gameTypeVariables[this.gameCategory].answers === 'nbClicks') {
        let answers = this.gameInfo.parametersMcq.answers;
        let trueLabels = [];
        let falseLabels = [];
        if (answers) {
          answers.forEach((answer) => {
            if (answer.isCorrect === true) {
              trueLabels.push(
                this.isMcqImage ? answer.picture.url : answer.text.fr
              );
            } else {
              falseLabels.push(
                this.isMcqImage ? answer.picture.url : answer.text.fr
              );
            }
          });
        }
        // return trueLabels.concat(falseLabels);
        this.gameProperties[this.gameCategory].labels = {
          trueLabels,
          falseLabels,
        };
        return { trueLabels, falseLabels };
      } else if (this.gameCategory === 'picture') {
        labels = this.labelsMission;
      } else if (this.getStatsGame) {
        const answers = this.getStatsGame;
        labels = answers.map((answer) => {
          return answer[this.gameTypeVariables[this.gameCategory].label];
        });
      }

      this.gameProperties[this.gameCategory].labels = labels;
      return labels;
    },
  },
  methods: {
    changeMissionTab(newTab) {
      this.missionTab = newTab;
      return this.missionTab;
    },
  },
  watch: {
    missionId(newValue, oldValue) {
      this.missionTab = 'mission';
      return newValue;
    },
    missionTab() {
      console.log('watch mission tab change');
      this.gameProperties = {};
      if (this.missionTab !== 'mission') {
        this.gameProperties[this.gameCategory] = { data: [], labels: {} };
      } else {
        this.gameProperties.mission = {
          data: this.valuesMission,
          labels: this.labelsMission,
        };
      }
    },
    statsMission() {
      console.log('watch statsMission');
      this.gameProperties = {};
      this.gameProperties.mission = {
        data: this.valuesMission,
        labels: this.labelsMission,
      };
    },
  },
};
</script>
<style lang="sass" scoped>
.flexImage
  padding: 0 0 0 !important
.chipText
  color: #009999
.centerChart
  position: absolute
  top : 50%
  left: 50%
  transform: translate(-50%, -50%);
  width: 95%
.banner
  position: absolute
  top : 50%
  left: 50%
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center
.missionName
  line-height: 120%
  text-align: middle
  text-justify: center
  height: 32px;
.pointerClass
  cursor: pointer;
.v-chip--active:after, .v-chip--selected:after, .v-chip:focus:not(.v-chip--disabled):after
  background: white
.v-tabs__div
  text-transform: none !important
</style>
